import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import UiIcon from './ui/UiIcon';

// Burger menu replacing the tab strip and Manage menu on narrow screens (CSS shows one or the other).
function MobileMenu({ groups, email, onSignOut }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => { setOpen(false); }, [pathname]);

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('pointerdown', close);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('pointerdown', close);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const items = groups.flat();
  const current = items
    .filter(i => pathname === i.to || pathname.startsWith(i.to + '/'))
    .sort((a, b) => b.to.length - a.to.length)[0];

  return (
    <div ref={ref} className="mobile-menu">
      <button
        type="button"
        className="mobile-menu-trigger"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Menu"
        onClick={() => setOpen(o => !o)}
      >
        <UiIcon name={open ? 'close' : 'menu'} />
        <span className="mobile-menu-current">{current?.label || 'Norppa Admin'}</span>
      </button>
      {open && (
        <div className="mobile-menu-panel" role="menu">
          {groups.map((group, i) => (
            <div key={i} className="mobile-menu-group">
              {group.map(item => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  role="menuitem"
                  className={({ isActive }) => `mobile-menu-item ${isActive ? 'active' : ''}`}
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          ))}
          <div className="mobile-menu-group">
            <div className="menu-note" title={email}>{email}</div>
            <button type="button" role="menuitem" className="mobile-menu-item mobile-menu-danger" onClick={onSignOut}>
              Sign out
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default MobileMenu;
